import { Component } from '@angular/core';

@Component({
  selector: 'icon-concluded-campaign',
  templateUrl: './icon-concluded-campaign.component.html',
  styleUrls: ['./icon-concluded-campaign.component.scss']
})
export class IconConcludedCampaignComponent {}
